import axios from '@/utils/request'

const listUrl = '/data/contractWithdrawDeposit/page'
const list = async (body) => {
  const { data } = await axios.post(listUrl, body)
  return data.data
}

const needLoginUrl = []

export default {
  needLoginUrl,
  list,
}
